import { computed, makeObservable, observable } from 'mobx';
import RootStore from './RootStore';
import {
  IFilters,
  KeywordTypeEnum,
  DateTypeEnum,
  SortOrderEnum,
  CompleteStatusEnum,
} from '../interfaces/filters.interface';
import { jstMoment } from '../utils/date';

export default class SearchStore {
  private rootStore: RootStore;

  @observable filters: IFilters;
  @observable appliedFilters: IFilters;

  // for future expansion
  // /**
  //  * Mapping of the DateIsClearedType
  //  * This set the label used by the INPUT and the interval period related to today.
  //  *
  //  * @type {Record<
  //  *     DateIsClearedTypeKey,
  //  *     DateIsClearedTypeObject
  //  *   >}
  //  * @memberof SearchStore
  //  */
  // dateIsClearedTypeKeyObject: Record<
  //   DateIsClearedTypeKey,
  //   DateIsClearedTypeObject
  // > = {
  //   '2_YEARS': { label: '2年間', interval: { type: 'days', number: 729 } },
  //   '1_WEEK': { label: '1週間', interval: { type: 'weeks', number: 1 } },
  //   '1_MONTH': { label: '1か月', interval: { type: 'months', number: 1 } },
  //   '1_YEAR': { label: '1年間', interval: { type: 'years', number: 1 } },
  // };
  //
  // @computed
  // get replyCheckboxDisabled(): boolean {
  //   return this.filters.completeStatus !== CompleteStatusEnum.NotComplete;
  // }

  @computed
  get isSortedByLastMessage(): boolean {
    return [SortOrderEnum.LastDesc, SortOrderEnum.LastAsc].includes(
      this.appliedFilters.sortOrder,
    );
  }

  // for future expansion
  //
  // @computed
  // get isSortedAsc(): boolean {
  //   return [SortOrderEnum.LastAsc, SortOrderEnum.InitialAsc].includes(
  //     this.appliedFilters.sortOrder,
  //   );
  // }
  //
  // @computed
  // get hasKeyword(): boolean {
  //   return !!this.appliedFilters.keyword.value;
  // }
  //
  // /**
  //  * This Timestamp is the initial time for the cache data.
  //  * When this is reset to jstMoment().valueOf() that means all cache data is Invalid and the request will be done again.
  //  */
  // @observable forceRequestInitialTimestamp: number = jstMoment().valueOf();
  //
  // /**
  //  * This function receives the string in the DateIsClearedTypeKey group and returns
  //  * the text to be shwon:
  //  * Example: 2年間 (2018/10/31 - 2020/10/29)
  //  *
  //  * @param {string} dateIsClearedTypeParam
  //  * @returns
  //  * @memberof SearchStore
  //  */
  // @bind
  // getFilterTypeLabelAndDate(dateIsClearedTypeParam: string) {
  //   const dateIsClearedTypeObject =
  //     this.dateIsClearedTypeKeyObject[
  //       dateIsClearedTypeParam as DateIsClearedTypeKey
  //     ];
  //   return `${dateIsClearedTypeObject.label} (${jstMoment()
  //     .subtract(
  //       dateIsClearedTypeObject.interval.number,
  //       dateIsClearedTypeObject.interval.type,
  //     )
  //     .format('YYYY/MM/DD')} - ${jstMoment().format('YYYY/MM/DD')})`;
  // }
  //
  // @action
  // onClearDateFilter = async (type: string) => {
  //   runInAction(() => {
  //     this.filters.date.clearedType = type;
  //     this.filters.date.isCleared = true;
  //   });
  //   await this.applyFilter();
  // };
  //
  // @action
  // onChangeCompleteStatusFilter = async (status: CompleteStatusEnum) => {
  //   runInAction(() => {
  //     if (this.rootStore.serviceStore.showCompleteButton) {
  //       this.filters.completeStatus = status;
  //     } else {
  //       this.filters.completeStatus = status;
  //       if (status === CompleteStatusEnum.All) {
  //         this.filters.replyStatus['replied'] = true;
  //         this.filters.replyStatus['nonReplied'] = true;
  //       }
  //     }
  //   });
  //   await this.applyFilter();
  // };
  //
  // @action
  // onChangeReplyStatusFilter = async (key: 'replied' | 'nonReplied') => {
  //   runInAction(() => {
  //     if (this.rootStore.serviceStore.showCompleteButton) {
  //       this.filters.replyStatus[key] = !this.filters.replyStatus[key];
  //     } else {
  //       this.filters.replyStatus[key] = true;
  //       this.filters.replyStatus[key === 'replied' ? 'nonReplied' : 'replied'] =
  //         false;
  //       this.filters.completeStatus = CompleteStatusEnum.NotComplete;
  //     }
  //   });
  //   await this.applyFilter();
  // };
  //
  // @action
  // onChangeDateRangeFilter = async (from: string, to: string) => {
  //   console.log('onChangeDateRangeFilter', { from, to });
  //   runInAction(() => {
  //     this.filters.date.from = jstMoment(from).format('YYYY-MM-DDTHH:mm:ss');
  //     this.filters.date.to = jstMoment(to).format('YYYY-MM-DDTHH:mm:ss');
  //     this.filters.date.isCleared = false;
  //   });
  //   await this.applyFilter();
  // };
  //
  // @action
  // onChangeDateFilter = async (type: string) => {
  //   runInAction(() => {
  //     this.filters.date.clearedType = type;
  //     this.filters.date.isCleared = true;
  //   });
  //   await this.applyFilter();
  // };
  //
  // @action
  // onChangeKeywordValueFilter = (newValue: string) => {
  //   runInAction(() => {
  //     this.filters.keyword.value = newValue;
  //   });
  // };
  //
  // @action
  // onChangeCategoryIdFilter = (categoryId: number | null) => {
  //   runInAction(() => {
  //     this.filters.categoryId = categoryId;
  //   });
  // };
  //
  // @action
  // private formatKeywordValue = () => {
  //   runInAction(() => {
  //     this.filters.keyword.value = this.filters.keyword.value.trim();
  //   });
  // };
  //
  // @action
  // applyFilter = async () => {
  //   this.formatKeywordValue();
  //   this.appliedFilters = this.filters;
  //   console.log('applyFilter', { filters: toJS(this.appliedFilters) });
  //
  //   await this.rootStore.inquiryStore.fetchInquiryData();
  // };
  //
  // @action
  // onChangeSortOrder = async (sortOrder: SortOrderEnum) => {
  //   runInAction(() => {
  //     this.filters.sortOrder = sortOrder;
  //   });
  //   await this.applyFilter();
  // };
  //
  private getDefaultFilter = (): IFilters => {
    const toDate = jstMoment().endOf('day');
    const fromDate = toDate.clone().startOf('day').subtract(180, 'days');

    return {
      keyword: {
        value: '',
        type: KeywordTypeEnum.Content,
      },
      date: {
        to: toDate.format('YYYY-MM-DDTHH:mm:ss'),
        from: fromDate.format('YYYY-MM-DDTHH:mm:ss'),
        type: DateTypeEnum.RegTime,
        isCleared: false,
        clearedType: '2_YEARS',
      },
      categoryId: null,
      completeStatus: CompleteStatusEnum.All,
      replyStatus: {
        replied: false,
        nonReplied: true,
      },
      sortOrder: SortOrderEnum.LastDesc,
    };
  };

  constructor(rootStore: RootStore) {
    makeObservable(this);
    this.rootStore = rootStore;

    // filters
    this.filters = this.getDefaultFilter();
    this.appliedFilters = this.filters;
  }
}
